(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../core/convert', '../util/lang'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../core/convert'), require('../util/lang'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.convert, global.lang);
    global.convertStringMethod = mod.exports;
  }
})(this, function (exports, _convert, _lang) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.convertStringMethod = convertStringMethod;

  function convertStringMethod(name) {
    return (0, _convert.convert)(function (arg) {
      var _toString;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_toString = (0, _lang.toString)(arg))[name].apply(_toString, args);
    });
  }
});